<ng-container *ngIf="vraag">
  <div class="ols-vraag" [ngClass]="vraagClass">
    <div *ngIf="ietjeTonen" class="icon-verz ial-al_017"></div>
    <div
      *ngIf="(vraag.control === controltype.Label || vraag.control === controltype.SingleChoiceRepair || vraag.control === controltype.SingleChoiceRepairWithSearch) && vraag.stappenplan_stappen"
      class="ols-icon-titel" [ngClass]="vraag.stappenplan_stappen"></div>
    <div *ngIf="vraagtitelTonen" class="ols-title" [innerHTML]="geefTitel(vraag)"></div>
    <div *ngIf="vraag.stappenplan_detail && vraag.control !== controltype.SingleChoiceRepairWithSearch && vraag.control !== controltype.MobielSchadeMelden"
      [innerHTML]="vraag.stappenplan_detail" class="ols-subtitle"></div>

    <div *ngIf="vraag.vraagregels" class="ols-tips">
      <div class="ols-lamp"></div>
      <div class="ols-tip" id="line-clamp">
        <div>
          <span *ngFor="let regel of vraag.vraagregels" [innerHTML]="regel"></span>
          <a class="lees-meer">Lees meer</a>
          <a class="lees-minder">Lees minder</a>
        </div>
      </div>
    </div>

    <div class="ols-vraag-content">
      <app-contactgegevens *ngIf="vraag.control === controltype.ContactGegevens" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-contactgegevens>
      <app-date-picker *ngIf="vraag.control === controltype.Kalender || vraag.control === controltype.KalenderDmj"
        [isCurrentVraag]="isCurrentVraag" [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)" class="ols-vraag-control"></app-date-picker>
      <app-date-van-tot-picker *ngIf="vraag.control === controltype.KalenderVanTot" [isCurrentVraag]="isCurrentVraag"
        [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)" class="ols-vraag-control">
      </app-date-van-tot-picker>
      <app-time-picker *ngIf="vraag.control === controltype.Tijd" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-time-picker>
      <app-failure *ngIf="vraag.control === controltype.Failure" [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)" class="ols-vraag-control"></app-failure>
      <app-label *ngIf="vraag.control === controltype.Label" [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)" class="ols-vraag-control"></app-label>
      <app-multiselect *ngIf="vraag.control === controltype.MultiChoice" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        [isCurrentVraag]="isCurrentVraag" class="ols-vraag-control"></app-multiselect>
      <app-multiupload *ngIf="vraag.control === controltype.Blob && vraag.vraagtype === vraagtype.MultiUpload"
        [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)" [isCurrentVraag]="isCurrentVraag"
        class="ols-vraag-control"></app-multiupload>
      <app-bedrag *ngIf="vraag.control === controltype.Bedrag" [isCurrentVraag]="isCurrentVraag" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-bedrag>
      <app-decimal *ngIf="vraag.control === controltype.Decimaal" [isCurrentVraag]="isCurrentVraag" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-decimal>
      <app-info *ngIf="vraag.control === controltype.Info" [isCurrentVraag]="isCurrentVraag" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-info>
      <app-number *ngIf="vraag.control === controltype.Number" [isCurrentVraag]="isCurrentVraag" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-number>
      <app-referentie *ngIf="vraag.control === controltype.Referentie" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-referentie>
      <app-telefoon
        *ngIf="vraag.control === controltype.Telefoon1 || vraag.control === controltype.Telefoon2 || vraag.control === controltype.Telefoon3"
        [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)" class="ols-vraag-control"></app-telefoon>
      <app-radiobutton-list *ngIf="vraag.control === controltype.SingleChoice" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-radiobutton-list>
      <app-radiobutton-list *ngIf="vraag.control === controltype.SingleChoiceWithDescription" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-radiobutton-list>
      <app-radiobutton-list-coming-days *ngIf="vraag.control === controltype.SingleChoiceComingDates" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-radiobutton-list-coming-days>
      <app-radiobutton-list-repair *ngIf="vraag.control === controltype.SingleChoiceRepair" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-radiobutton-list-repair>
      <app-radiobutton-list-repair-with-search *ngIf="vraag.control === controltype.SingleChoiceRepairWithSearch"
        [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-radiobutton-list-repair-with-search>
      <app-single-choice-with-filter *ngIf="vraag.control === controltype.SingleChoiceWithSearch"
        [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-single-choice-with-filter>
      <app-ruithersteller *ngIf="vraag.control === controltype.Ruithersteller" [vraag]="vraag"
        class="ols-vraag-control"></app-ruithersteller>
      <app-woonglashersteller *ngIf="vraag.control === controltype.Woonglashersteller" [vraag]="vraag"
        class="ols-vraag-control"></app-woonglashersteller>
      <app-button-succes *ngIf="vraag.control === controltype.SuccesButton" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-button-succes>
      <app-msm *ngIf="vraag.control === controltype.MobielSchadeMelden" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-msm>
      <app-succes
        *ngIf="[controltype.Succes, controltype.SuccesFutureState, controltype.SuccesVerder, controltype.SuccesSchadecoach].includes(vraag.control)"
        [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)" class="ols-vraag-control"></app-succes>
      <app-summary *ngIf="vraag.control === controltype.Summary" [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)" class="ols-vraag-control"></app-summary>
      <app-textarea *ngIf="vraag.control === controltype.Tekst" [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)" class="ols-vraag-control"></app-textarea>
      <app-slider-single *ngIf="vraag.control === controltype.SliderSingle" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-slider-single>
      <app-tekstregel *ngIf="vraag.control === controltype.TekstRegel" [isCurrentVraag]="isCurrentVraag" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        class="ols-vraag-control"></app-tekstregel>
      <app-upload *ngIf="vraag.control === controltype.Blob && vraag.vraagtype !== vraagtype.MultiUpload"
        [vraag]="vraag" [antwoordResultaat]="antwoordResultaat"
        (antwoordResultaatChange)="onAntwoordResultaatChange($event)" class="ols-vraag-control ols-upload-control">
      </app-upload>
      <app-multiselect-doorvragen *ngIf="vraag.control === controltype.MultiChoiceDoorvragen" [vraag]="vraag"
        [antwoordResultaat]="antwoordResultaat" (antwoordResultaatChange)="onAntwoordResultaatChange($event)"
        [isCurrentVraag]="isCurrentVraag" class="ols-vraag-control"></app-multiselect-doorvragen>
    </div>
  </div>
</ng-container>